<template>
  <div class="content home-page faq-page">
    <div class="faq-layout">
      <div class="faq-header">
        <div class="page-back" @click="back">
          <img src="../../static/images/back.png"/>
        </div>
        <div class="faq-title">{{ $t('FAQ') }}</div>
        <div class="faq-header-space"></div>
      </div>

      <div class="faq-scroll">
        <div class="faq-content faq-body" v-if="list!=''">
          <div class="faq-html" v-html="list"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      list: []

    }
  },
  created() {
    this.getHome();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$parent.loadModal(true);
      let data = {
        type: '1'
      }
      that.$api.post('/api/index/help', data, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.list = r.data.content
        });
      })

    }
  }
}
</script>
<style scoped>
.faq-page {
  height: 100vh;
  min-height: 100vh !important;
  overflow: hidden;
  padding: 20px 0 0 !important;
}

.faq-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 0 24px;
  position: relative;
}

.faq-title {
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 1px;
  text-align: center;
  width: 100%;
}

.faq-header-space {
  display: none;
}

.faq-header .page-back {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 0;
  width: 50px;
  height: 50px;
}

.faq-header .page-back img {
  width: 26px;
}

.faq-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
  padding: 0 12px 12px;
}

.faq-body {
  background: #fff;
  border-radius: 0;
  color: #28000d;
  margin: 0;
  min-height: 100%;
  padding: 0;
  width: 100%;
}

.faq-html {
  color: #28000d;
  line-height: 1.6;
}

.faq-html :deep(a) {
  word-break: break-word;
}

@media (min-width: 751px) {
  .faq-page {
    height: 1703px !important;
    min-height: 1703px !important;
  }

  .faq-layout {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/faq.vue